import { useState, useEffect } from 'react';
import axios from 'axios';

const apiParkingBase = process.env.BUN_PUBLIC_PARKING_API_BASE;

export interface DropdownOption {
    id: number;
    parking_location_id: number;
    option_category: string;
    option_key: string;
    option_value: string;
    description: string;
    display_order: number;
    is_active: boolean;
    metadata: string;
}

export function useDropdownOptions(locationHash: string | null, category: string) {
    const [options, setOptions] = useState<DropdownOption[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get<{ data: DropdownOption[] }>(`${apiParkingBase}/api/public/dropdown-options`, {
            params: { locationHash, category }
        })
        .then(res => setOptions(res.data.data || []))
        .catch(console.error)
        .finally(() => setLoading(false));
    }, [locationHash, category]);

    return { options, loading };
}
